import React, { Component } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsModal from '../../../../common/modal/details-modal/details-modal';
import { StackedBarChart, SingleBarGraph } from '../../../../common/graph/bar-graph.component';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import ButtonIcon from '../../../../button';
import { TABLE_PAGINATION_KEY, DEFAULT_PAGE_VALUE, MODAL_CUSTOM_MESSAGE } from '../../../../../constants/external-constants';
import { invoiceSubLineActions } from '../../../../../store/external/invoice/subline-item.reducer';
import '../../../../common/table/table-component.css'
import '../invoice.css';
import Translation from "../../../../common/translation/translation.component";
import { Loading } from '../../../../common/loading';

import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
const TEST_DATA = {
    Headers:{
        ChargeType: {
            propName: "ChargeType",
            name: "Charge Type",
            isLink: false
        },
        Description: {
            propName: "Description",
            name: "Description",
            isLink: false
        },
        GrossAmount:{
            propName: "GrossAmount",
            name: "Gross Amount",
            isLink: false
        },
        NetAmount:{
            propName: "NetAmount",
            name: "Net Amount",
            isLink: false
        }, 
        Tax: {
            propName: "Tax",
            name: "Tax",
            isLink: false
        }
    },
    Data: {
        Items: [
            {
                ChargeType: "Domestic Fixed Calls",
                Description: "Voice,Peak..Rutherford NJ, Houston TX",
                GrossAmount: "100.00",
                NetAmount: "0.00",
                Tax: "0.00",
            },
            {
                ChargeType: "Domestic Fixed Calls",
                Description: "Voice,Peak..Rutherford NJ, Houston TX",
                GrossAmount: "100.00",
                NetAmount: "0.00",
                Tax: "0.00",
            },
            {
                ChargeType: "Domestic Fixed Calls",
                Description: "Voice,Peak..Rutherford NJ, Houston TX",
                GrossAmount: "100.00",
                NetAmount: "0.00",
                Tax: "0.00",
            },
            {
                ChargeType: "Domestic Mobile Calls",
                Description: "Voice,Peak..Rutherford NJ, Houston TX",
                GrossAmount: "100.00",
                NetAmount: "0.00",
                Tax: "0.00",
            },  
        
        ]
    },
    barChart:[
            {
                name: "Domestic Fixed calls",
                NetAmount: 0,
                GrossAmount:10,
                Tax: 0
            },
            {
                name: "Domestic Messaging",
                NetAmount: 0,
                GrossAmount:20,
                Tax: 0
            },
            {
                name: "Domestic Mobile Calls",
                NetAmount: 0,
                GrossAmount:30,
                Tax: 0
            },
            {
                name: "Domestic Mobile Data",
                NetAmount: 22,
                GrossAmount:40,
                Tax: 3
            },
            {
                name: "Domestic Mobile Messaging",
                NetAmount: 0,
                GrossAmount:50,
                Tax: 0
            },
            {
                name: "Fixed Fees and Other Fees",
                NetAmount: 0,
                GrossAmount:60,
                Tax: 0
            },
            {
                name: "International calls",
                NetAmount: 0,
                GrossAmount:70,
                Tax: 0
            },
            {
                name: "International Mobile Messaging",
                NetAmount: 0,
                GrossAmount:80,
                Tax: 0
            },
            {
                name: "Mobile Telephony",
                NetAmount: 3,
                GrossAmount:90,
                Tax: 27
            },
            {
                name: "Premium Services",
                NetAmount: 0,
                GrossAmount:100,
                Tax: 0
            },
            {
                name: "Roaming Voice",
                NetAmount: 12,
                GrossAmount:110,
                Tax: 0
                
            },
            {
                name: "Roaming Data",
                NetAmount: 0,
                GrossAmount:120,
                Tax: 4
               
            },
           
            {
                name: "Other Mobile Telephony Cost",
                NetAmount: 0,
                GrossAmount:130,
                Tax: 0
            }

  ],
 
}


class SublineItemComponent extends Component {
    constructor(){
        super()
        this.DisplaySearchBox = this.DisplaySearchBox.bind(this)
        this.state = {
            showModal: false,
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        this.props.getSubLineGrossSummary(this.props.selectedItem);
        this.props.getAllSubLineItems(this.props.selectedItem);
    }

    componentWillUnmount() {
        this.props.setDefaultSubLineItem();
    }
    resizePage = (value) => {
        const { getAllSubLineItems, resizeAllSubLineItemPage, selectedItem } = this.props;
        resizeAllSubLineItemPage(value);
        getAllSubLineItems(selectedItem);
    }

    DisplaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    onColumnSortSubLineItems = (columnClicked, isSortedAsc) => {
        const { selectedItem, sortAllSubLineItems } = this.props;
        sortAllSubLineItems(columnClicked, isSortedAsc, selectedItem);
    }

    onGetInvoiceSubLineItems = (pageIndex) => {
        const { selectedItem, getAllSubLineItems } = this.props;
        getAllSubLineItems(selectedItem, pageIndex);
    }

    onColumnSearchSubLineItems = () => {
        const { selectedItem, getAllSubLineItems } = this.props;
        getAllSubLineItems(selectedItem, 0);
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractAllSublineItems(this.props.selectedItem, this.props.invoiceNumber, this.props.billedCircuitId);
        }
    }

    filteredChartData = () => {
        const { subLineGrossSummary, allSubLineItems: { Data: { Items } } } = this.props.invoiceSubLine;
        let data = [];
        if (subLineGrossSummary?.length > 0) {
            data = subLineGrossSummary.filter((item) => {
                return Items.filter(i => i.ChargeType?.toLowerCase() == item.ChargeType?.toLowerCase()).length > 0;
            });
        }
      
        return data;
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }
    render(){
        const { invoiceSubLine, setAllSubLineItemColSearchStr, isReadOnly } = this.props;
        const singleBarGraphData = this.filteredChartData();

        return (
            <DetailsModal showModal={this.props.showModal} customClassName="sublineModal" handleClose={this.props.handleClose} title={this.props.title}>
            <div className="details-container  data-table">
                    <h1 className="subline-item-header"><Translation translationKey="gross_summary_per_charge_type" /></h1>
                    {this.props.invoiceSubLine.isSublineGrossSummaryLoaded ?
                        <SingleBarGraph data={invoiceSubLine.subLineGrossSummary ? invoiceSubLine.subLineGrossSummary : [] } />
                        :
                        this.loading()
                    } 

                <div className="button-header__alignment">
                    <ButtonIcon 
                        onClick={this.DisplaySearchBox} 
                        iconLeft="file-magnifying-glass" 
                        iconSize="17px" 
                        customClassName="header-option-list header-filter-button" 
                        labelName="Search"
                    />

                    <ButtonIcon
                        onClick={!isReadOnly ? (e) => this.onClickExtract(e) : () => {}}
                        iconLeft="cloud-arrow-down" iconSize="17px"
                        customClassName={`${!isReadOnly ? "header-option-list" : ""} header-filter-button`}
                        isDisable={isReadOnly}
                        labelName="Extract List"
                    />
                    </div>
                    {this.props.invoiceSubLine.isAllSubLineItemLoaded ?
                    <TablePagination
                        key={TABLE_PAGINATION_KEY.invoiceInvoice}  
                        classNameWrapper="overflow-auto table__column--description-wide" 
                        columns={invoiceSubLine.allSubLineItems.Headers}
                        pageList={invoiceSubLine.allSubLineItems.Data}
                        pages={invoiceSubLine.allSubLineItems.Pagination}
                        rowClickAction={() => {}}
                        paginationAction={this.onGetInvoiceSubLineItems}
                        onColumnClick={this.onColumnSortSubLineItems}
                        onColumnSearch={() => { this.onColumnSearchSubLineItems() }}
                        onColumnSearchChange={setAllSubLineItemColSearchStr}
                        isColSearchShow={this.state.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={invoiceSubLine.allSubLineItems.Pagination.TotalEntries}
                    />
                    :
                    this.loading()
                    }
            </div>
        </DetailsModal> 
    );
    } 
}

export default connect (
    state => {
        const { invoiceSubLine } = state;

        return {
            invoiceSubLine
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceSubLineActions),
        dispatch
    )
)(SublineItemComponent);

